import React from 'react'
// import PropTypes from 'prop-types'

import { timezones } from '../../utils/timezone'

import Select from './Select'

const SelectTimezone = ({ ...rest }) => (
    <Select
      mutli={false}
      options={timezones.map(({ label, tzCode}) => ({
        label,
        value: tzCode,
      }))}
      {...rest}
    />
  )

SelectTimezone.propTypes = {
}
SelectTimezone.defaultProps = {
}

export default SelectTimezone
